import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import styles from './styles.module.scss';

const Preloader = ({ className, speed, height, iconSize }) => (
	<div className={cx(styles.Preloader, className)} style={{ height }}>
		<Icon
			icon="preloader"
			className={cx(
				styles.Preloader_Icon,
				styles[`Preloader_Icon__${iconSize}`],
				styles[`Preloader_Icon__${speed}`]
			)}
		/>
	</div>
);

Preloader.propTypes = {
	className: PropTypes.string,
	height: PropTypes.string,
	speed: PropTypes.oneOf(['slow', 'fast']),
	iconSize: PropTypes.oneOf(['small', 'big'])
};

Preloader.defaultProps = {
	speed: 'slow'
};

export default Preloader;
